import { createApi } from "@reduxjs/toolkit/query/react";
import { ITEM, HttpMethod, TagId, TagType } from "../../data/constants";
import { createBaseQuery } from "../helpers/baseQueryHelper";
import { Item } from "../../data/interfaces";

const itemApi = createApi({
  reducerPath: ITEM.reducerPath,
  baseQuery: createBaseQuery(ITEM.baseUrl),
  tagTypes: ITEM.tagTypes,
  endpoints(builder) {
    return {
      getMyItems: builder.query<Item[], void>({
        query: () => ({
          url: "/my-items",
          method: HttpMethod.GET,
        }),
        providesTags: () => [{ type: TagType.Item, id: TagId.LIST }],
      }),
      toggleItemStock: builder.mutation<
        void,
        { itemId: string; haveStock: boolean }
      >({
        query: ({ itemId, haveStock }) => ({
          url: `/${itemId}/stock`,
          method: HttpMethod.PATCH,
          params: { haveStock },
        }),
        invalidatesTags: [{ type: TagType.Item, id: TagId.LIST }],
      }),
    };
  },
});

export const { useGetMyItemsQuery, useToggleItemStockMutation } = itemApi;

export { itemApi };
